import { Injectable, signal, inject } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PwaUpdateService {
  private swUpdate = inject(SwUpdate);

  // Signal to track if an update is available
  updateAvailable = signal(false);

  // Signal for update status messages
  updateMessage = signal('');

  constructor() {
    if (this.swUpdate.isEnabled) {
      this.checkForUpdates();
    }
  }

  /**
   * Check for application updates
   */
  private checkForUpdates(): void {
    // Subscribe to version updates
    this.swUpdate.versionUpdates
      .pipe(
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
      )
      .subscribe(evt => {
        this.updateAvailable.set(true);
        this.updateMessage.set(
          `A new version of the application is available. Current version: ${evt.currentVersion.hash}, New version: ${evt.latestVersion.hash}`
        );
        console.log('New version available:', evt);
      });

    // Check for updates every 6 hours (optional)
    if (this.swUpdate.isEnabled) {
      setInterval(() => {
        this.swUpdate.checkForUpdate().then(() => {
          console.log('Checked for updates');
        });
      }, 6 * 60 * 60 * 1000); // 6 hours
    }
  }

  /**
   * Activate the update and reload the application
   */
  activateUpdate(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.activateUpdate().then(() => {
        // Reload the page to load the new version
        document.location.reload();
      });
    }
  }

  /**
   * Dismiss the update notification
   */
  dismissUpdate(): void {
    this.updateAvailable.set(false);
  }

  /**
   * Manually check for updates
   */
  checkForUpdate(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.checkForUpdate().then(updateFound => {
        if (updateFound) {
          console.log('Update found!');
        } else {
          console.log('No update available');
        }
      });
    }
  }
}
